/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductSelectionResponse = {
    /**
     * Name of the product
     */
    product_name: string;
    /**
     * Quadrant where the product is placed
     */
    quadrant: ProductSelectionResponse.quadrant;
};
export namespace ProductSelectionResponse {
    /**
     * Quadrant where the product is placed
     */
    export enum quadrant {
        TOP_LEFT = 'top_left',
        TOP_RIGHT = 'top_right',
        BOTTOM_LEFT = 'bottom_left',
        BOTTOM_RIGHT = 'bottom_right',
    }
}

